module.exports = "<app-contenedor-formulario *ngIf=\"modo === 'experto'\"></app-contenedor-formulario>\r\n<app-contenedor-formulario-no-experto *ngIf=\"modo === 'no-experto'\"></app-contenedor-formulario-no-experto>"


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/init-container/init-container.component.html
// module id = ../../../../../src/app/components/init-container/init-container.component.html
// module chunks = main